/* ============================================
   MOTOBEAR COLOMBIA — THEME JS v2.0
   Inmersivo · Animado · Street Premium
============================================ */
(function () {
  'use strict';

  /* ====== HELPERS ====== */
  function formatMoney(cents) {
    return '$' + (cents / 100).toLocaleString('es-CO', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
  }
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return (ctx || document).querySelectorAll(sel); }

  /* ====== DARK / LIGHT MODE ====== */
  var savedTheme = localStorage.getItem('motobear-theme') || 'dark';
  document.documentElement.setAttribute('data-theme', savedTheme);

  function initThemeToggle() {
    qsa('[data-theme-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var current = document.documentElement.getAttribute('data-theme');
        var next = current === 'dark' ? 'light' : 'dark';
        document.documentElement.setAttribute('data-theme', next);
        localStorage.setItem('motobear-theme', next);
      });
    });
  }

  /* ====== LOADER ====== */
  function initLoader() {
    var loader = qs('#bear-loader');
    if (!loader) return;
    /* Animate each char */
    var chars = qsa('.loader-char', loader);
    chars.forEach(function (c, i) {
      c.style.animationDelay = (i * 0.06) + 's';
    });
    setTimeout(function () {
      loader.classList.add('hide');
      setTimeout(function () { loader.style.display = 'none'; }, 700);
    }, 1600);
  }

  /* ====== CUSTOM CURSOR ====== */
  function initCursor() {
    if (window.matchMedia('(pointer: coarse)').matches) return;
    var dot  = document.createElement('div'); dot.className  = 'cursor-dot';
    var ring = document.createElement('div'); ring.className = 'cursor-ring';
    document.body.appendChild(dot);
    document.body.appendChild(ring);
    var mx = -100, my = -100, rx = -100, ry = -100;
    document.addEventListener('mousemove', function (e) { mx = e.clientX; my = e.clientY; });
    (function animateCursor() {
      rx += (mx - rx) * 0.12; ry += (my - ry) * 0.12;
      dot.style.left  = mx + 'px'; dot.style.top  = my + 'px';
      ring.style.left = rx + 'px'; ring.style.top = ry + 'px';
      requestAnimationFrame(animateCursor);
    })();
    document.addEventListener('mouseover', function (e) {
      var el = e.target.closest('a,button,.category-card,.product-card');
      if (el) { dot.classList.add('hover'); ring.classList.add('hover'); }
      else     { dot.classList.remove('hover'); ring.classList.remove('hover'); }
    });
    document.addEventListener('mouseleave', function () { dot.style.opacity = '0'; ring.style.opacity = '0'; });
    document.addEventListener('mouseenter', function () { dot.style.opacity = ''; ring.style.opacity = ''; });
  }

  /* ====== SCROLL PROGRESS BAR ====== */
  function initScrollProgress() {
    var bar = document.createElement('div');
    bar.className = 'scroll-progress';
    document.body.appendChild(bar);
    window.addEventListener('scroll', function () {
      var h = document.documentElement;
      var max = h.scrollHeight - h.clientHeight;
      bar.style.width = (max > 0 ? (h.scrollTop / max) * 100 : 0) + '%';
    }, { passive: true });
  }

  /* ====== HEADER SCROLL ====== */
  function initHeader() {
    var header = qs('.site-header');
    if (!header) return;
    var prevScroll = 0;
    function onScroll() {
      var sy = window.scrollY;
      if (sy > 40) header.classList.add('scrolled'); else header.classList.remove('scrolled');
      prevScroll = sy;
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ====== SCROLL TO TOP ====== */
  function initScrollTop() {
    var btn = qs('.scroll-top-btn');
    if (!btn) return;
    window.addEventListener('scroll', function () {
      btn.classList.toggle('visible', window.scrollY > 450);
    }, { passive: true });
    btn.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
  }

  /* ====== MOBILE MENU ====== */
  function initMobileMenu() {
    var toggle = qs('#mobile-toggle'), menu = qs('#mobile-menu');
    if (!toggle || !menu) return;
    toggle.addEventListener('click', function () {
      var open = menu.classList.toggle('open');
      toggle.classList.toggle('open');
      document.body.style.overflow = open ? 'hidden' : '';
    });
    qsa('.mobile-nav-link', menu).forEach(function (link) {
      link.addEventListener('click', function () {
        var sub = link.nextElementSibling;
        if (sub && sub.classList.contains('mobile-subnav')) {
          sub.classList.toggle('open');
          var icon = link.querySelector('i');
          if (icon) icon.style.transform = sub.classList.contains('open') ? 'rotate(90deg)' : '';
        }
      });
    });
  }

  /* ====== HERO SLIDER ====== */
  function initHeroSlider() {
    var slider    = qs('.hero-slider');
    if (!slider) return;
    var slides    = qsa('.hero-slide', slider);
    var dots      = qsa('.hero-dot');
    var fill      = qs('.hero-progress-fill');
    var counterEl = qs('.hero-slide-counter');
    var prevBtn   = qs('[data-hero-prev]');
    var nextBtn   = qs('[data-hero-next]');
    if (!slides.length) return;

    var total    = slides.length;
    var current  = 0;
    var duration = 6000; // ms per slide
    var elapsed  = 0;
    var timer    = null;
    var raf      = null;
    var lastTime = null;

    function goTo(idx) {
      var leaving = slides[current];
      leaving.classList.remove('active');
      leaving.classList.add('prev');
      current = ((idx % total) + total) % total;
      var arriving = slides[current];
      /* Forzar reflow para re-disparar la transition opacity/transform del contenido */
      var content = arriving.querySelector('.hero-slide__content');
      if (content) { content.style.opacity = '0'; content.style.transform = 'translateY(24px)'; }
      arriving.offsetHeight; /* reflow */
      requestAnimationFrame(function() {
        requestAnimationFrame(function() {
          if (content) { content.style.opacity = ''; content.style.transform = ''; }
          arriving.classList.add('active');
          setTimeout(function() { leaving.classList.remove('prev'); }, 900);
        });
      });
      initSpeedLines(arriving);
      updateDots();
      updateCounter();
      elapsed = 0;
    }

    function updateDots() {
      dots.forEach(function (d, i) { d.classList.toggle('active', i === current); });
    }
    function updateCounter() {
      if (!counterEl) return;
      counterEl.innerHTML = '<span>' + String(current + 1).padStart(2, '0') + '</span> / ' + String(total).padStart(2, '0');
    }

    /* progress bar RAF */
    function progressStep(ts) {
      if (!lastTime) lastTime = ts;
      elapsed += ts - lastTime;
      lastTime = ts;
      if (fill) fill.style.width = Math.min(100, (elapsed / duration) * 100) + '%';
      if (elapsed >= duration) { elapsed = 0; lastTime = null; goTo(current + 1); }
      raf = requestAnimationFrame(progressStep);
    }

    function startProgress() { lastTime = null; raf = requestAnimationFrame(progressStep); }
    function stopProgress()  { if (raf) cancelAnimationFrame(raf); raf = null; }

    /* controls */
    dots.forEach(function (d, i) { d.addEventListener('click', function () { stopProgress(); goTo(i); startProgress(); }); });
    if (prevBtn) prevBtn.addEventListener('click', function () { stopProgress(); goTo(current - 1); startProgress(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { stopProgress(); goTo(current + 1); startProgress(); });

    /* keyboard */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft')  { stopProgress(); goTo(current - 1); startProgress(); }
      if (e.key === 'ArrowRight') { stopProgress(); goTo(current + 1); startProgress(); }
    });

    /* touch */
    var touchStartX = 0;
    slider.addEventListener('touchstart', function (e) { touchStartX = e.changedTouches[0].clientX; }, { passive: true });
    slider.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - touchStartX;
      if (Math.abs(dx) > 40) { stopProgress(); goTo(current + (dx < 0 ? 1 : -1)); startProgress(); }
    }, { passive: true });

    /* pause on hover */
    slider.addEventListener('mouseenter', function () { stopProgress(); });
    slider.addEventListener('mouseleave', function () { startProgress(); });

    /* init */
    slides[0].classList.add('active');
    initSpeedLines(slides[0]);
    updateDots();
    updateCounter();
    startProgress();
  }

  /* ====== SPEED LINES ====== */
  function initSpeedLines(slideEl) {
    if (!slideEl) return;
    var container = slideEl.querySelector('.hero-slide__lines');
    if (!container) return;
    container.innerHTML = '';
    for (var i = 0; i < 10; i++) {
      var line = document.createElement('div');
      line.className = 'speed-line';
      line.style.cssText = [
        '--top:' + (10 + Math.random() * 80) + '%',
        '--w:'   + (25 + Math.random() * 45) + '%',
        '--dur:' + (3.2 + Math.random() * 4.5) + 's',
        '--delay:-' + (Math.random() * 7) + 's'
      ].join(';');
      container.appendChild(line);
    }
  }

  /* ====== REVEAL ON SCROLL ====== */
  function initReveal() {
    var els = qsa('.reveal, .reveal-left, .reveal-scale');
    if (!('IntersectionObserver' in window) || !els.length) {
      els.forEach(function (el) { el.classList.add('visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('visible'); io.unobserve(entry.target); }
      });
    }, { threshold: 0.1 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ====== COUNTER ANIMATION ====== */
  function initCounters() {
    var els = qsa('.counter-val[data-target]');
    if (!els.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el     = entry.target;
        var target = parseInt(el.dataset.target, 10);
        var duration = 1800;
        var start    = performance.now();
        io.unobserve(el);
        (function update(ts) {
          var elapsed = ts - start;
          var progress = Math.min(elapsed / duration, 1);
          var eased = 1 - Math.pow(1 - progress, 3); /* ease out cubic */
          el.textContent = Math.round(eased * target).toLocaleString('es-CO');
          if (progress < 1) requestAnimationFrame(update);
        })(start);
      });
    }, { threshold: 0.4 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ====== PRODUCT TABS ====== */
  function initProductTabs() {
    var tabs = qsa('.product-tab');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) { t.classList.remove('active'); });
        tab.classList.add('active');
        qsa('.product-tab-panel').forEach(function (p) { p.style.display = 'none'; });
        var panel = qs('#' + tab.dataset.tab);
        if (panel) { panel.style.display = 'grid'; initReveal(); }
      });
    });
  }

  /* ====== CART DRAWER ====== */
  var cartDrawer  = qs('#cart-drawer');
  var cartOverlay = qs('#cart-overlay');

  function openCart() {
    if (!cartDrawer || !cartOverlay) return;
    cartDrawer.classList.add('open'); cartOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
    updateCartDrawer();
  }
  function closeCart() {
    if (!cartDrawer || !cartOverlay) return;
    cartDrawer.classList.remove('open'); cartOverlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  function initCart() {
    qsa('[data-cart-open]').forEach(function (btn) { btn.addEventListener('click', function (e) { e.preventDefault(); openCart(); }); });
    var closeBtn = qs('#cart-close');
    if (closeBtn) closeBtn.addEventListener('click', closeCart);
    if (cartOverlay) cartOverlay.addEventListener('click', closeCart);
  }

  /* Shipping bar */
  function updateShippingBar(cart) {
    var bar  = qs('#cart-shipping-bar');
    var text = qs('#cart-shipping-text');
    var fill = qs('#cart-shipping-fill');
    if (!bar || !text || !fill) return;
    var goal      = parseInt(bar.dataset.goal, 10) || 30000000;
    var remaining = Math.max(0, goal - cart.total_price);
    var progress  = Math.min(100, (cart.total_price / goal) * 100);
    fill.style.width = progress + '%';
    if (remaining > 0) {
      text.classList.remove('cart-shipping-bar__text--success');
      text.innerHTML = 'Gasta <strong>' + formatMoney(remaining) + '</strong> más para <strong>envío gratis</strong>';
    } else {
      text.classList.add('cart-shipping-bar__text--success');
      text.innerHTML = '<i class="fas fa-check-circle"></i> ¡Felicidades! Tienes <strong>envío gratis</strong>';
    }
  }

  function renderCartItems(cart) {
    var body       = qs('.cart-drawer__body');
    var countEl    = qs('.cart-drawer__count');
    var subtotalEl = qs('.cart-subtotal-value');
    var badge      = qs('#cart-badge');
    if (badge) badge.textContent = cart.item_count;
    if (countEl) countEl.textContent = '(' + cart.item_count + ')';
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
    if (!body) return;

    if (!cart.item_count) {
      body.innerHTML = '<div class="cart-empty"><i class="fas fa-shopping-cart"></i><p>Tu carrito está vacío</p><a href="/collections/all" class="btn btn--outline btn--sm" style="margin-top:8px;">Ver productos</a></div>';
      return;
    }
    var html = cart.items.map(function (item) {
      var img = item.image
        ? '<img src="' + item.image.replace('.jpg','_80x80.jpg') + '" alt="' + item.product_title + '" loading="lazy">'
        : '<i class="fas fa-motorcycle" style="font-size:28px;color:var(--bear-red);display:flex;align-items:center;justify-content:center;width:100%;height:100%;"></i>';
      return '<div class="cart-item" data-key="' + item.key + '">' +
        '<div class="cart-item__img">' + img + '</div>' +
        '<div>' +
          '<div class="cart-item__brand">' + (item.vendor || 'MOTOBEAR') + '</div>' +
          '<div class="cart-item__title">' + item.product_title + (item.variant_title && item.variant_title !== 'Default Title' ? ' — ' + item.variant_title : '') + '</div>' +
          '<div class="cart-item__bottom">' +
            '<div class="cart-item__qty">' +
              '<button class="qty-btn" data-action="decrease" data-key="' + item.key + '"><i class="fas fa-minus"></i></button>' +
              '<span class="qty-num">' + item.quantity + '</span>' +
              '<button class="qty-btn" data-action="increase" data-key="' + item.key + '"><i class="fas fa-plus"></i></button>' +
            '</div>' +
            '<div class="cart-item__price">' + formatMoney(item.final_line_price) + '</div>' +
          '</div>' +
          '<button class="cart-item__remove" data-key="' + item.key + '"><i class="fas fa-times"></i> Eliminar</button>' +
        '</div>' +
      '</div>';
    }).join('');
    body.innerHTML = html;

    qsa('.qty-btn', body).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.dataset.key, action = btn.dataset.action;
        var row = btn.closest('.cart-item'), qtyEl = row && row.querySelector('.qty-num');
        var qty = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
        changeCartItem(key, action === 'increase' ? qty + 1 : Math.max(0, qty - 1));
      });
    });
    qsa('.cart-item__remove', body).forEach(function (btn) {
      btn.addEventListener('click', function () { changeCartItem(btn.dataset.key, 0); });
    });
  }

  function changeCartItem(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(function (cart) {
      renderCartItems(cart); updateShippingBar(cart);
    });
  }

  function updateCartDrawer() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      renderCartItems(cart); updateShippingBar(cart);
    });
  }

  /* Add to cart */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.classList.contains('add-to-cart-form')) return;
    e.preventDefault();
    var btn = form.querySelector('.add-to-cart-btn');
    if (btn) { btn.disabled = true; btn.classList.add('loading'); btn.innerHTML = '<i class="fas fa-circle-notch fa-spin"></i>'; }
    fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
      .then(function (r) { return r.json(); })
      .then(function () {
        if (btn) { btn.disabled = false; btn.classList.remove('loading'); btn.innerHTML = '<i class="fas fa-shopping-cart"></i> Agregar al Carrito'; }
        openCart();
      }).catch(function () {
        if (btn) { btn.disabled = false; btn.classList.remove('loading'); btn.innerHTML = '<i class="fas fa-shopping-cart"></i> Agregar al Carrito'; }
      });
  });

  /* ====== MAGNETIC BUTTONS ====== */
  function initMagneticBtns() {
    if (window.matchMedia('(pointer: coarse)').matches) return;
    qsa('.btn--primary, .btn--gold').forEach(function (btn) {
      btn.addEventListener('mousemove', function (e) {
        var rect = btn.getBoundingClientRect();
        var cx = rect.left + rect.width / 2, cy = rect.top + rect.height / 2;
        var dx = (e.clientX - cx) * 0.18, dy = (e.clientY - cy) * 0.18;
        btn.style.transform = 'translate(' + dx + 'px,' + dy + 'px) translateY(-3px)';
      });
      btn.addEventListener('mouseleave', function () {
        btn.style.transform = '';
      });
    });
  }

  /* ====== PARALLAX HERO ====== */
  function initParallax() {
    var bg = qs('.hero-slide.active .hero-slide__bg');
    if (!bg || window.matchMedia('(pointer: coarse)').matches) return;
    window.addEventListener('scroll', function () {
      var sy = window.scrollY;
      var activeBg = qs('.hero-slide.active .hero-slide__bg');
      if (activeBg) activeBg.style.transform = 'scale(1) translateY(' + (sy * 0.18) + 'px)';
    }, { passive: true });
  }

  /* ====== ANNOUNCEMENT BAR pause ====== */
  function initAnnouncement() {
    var track = qs('.announcement-track');
    if (!track) return;
    track.addEventListener('mouseenter', function () { track.style.animationPlayState = 'paused'; });
    track.addEventListener('mouseleave', function () { track.style.animationPlayState = ''; });
  }

  /* ====== INIT ====== */
  document.addEventListener('DOMContentLoaded', function () {
    initThemeToggle();
    initScrollProgress();
    initLoader();
    initCursor();
    initHeader();
    initScrollTop();
    initMobileMenu();
    initHeroSlider();
    initReveal();
    initCounters();
    initProductTabs();
    initCart();
    initMagneticBtns();
    initParallax();
    initAnnouncement();

    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      updateShippingBar(cart);
      var badge = qs('#cart-badge');
      if (badge && cart.item_count > 0) badge.textContent = cart.item_count;
    }).catch(function () {});
  });

})();
